import React from 'react'
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import App from './App'
import Poupe from './poupe'
import PoupePolicy from './poupe/Policy'
import PoupeTerms from './poupe/Terms'
import Rosary from './rosary'
import RosaryPolicy from './rosary/Policy'
import RosaryTerms from './rosary/Terms'
import MercyChaplet from './mercychaplet'
import MercyChapletPolicy from './mercychaplet/Policy'
import MercyChapletTerms from './mercychaplet/Terms'
import Cookbook from './cookbook'
import CookbookPolicy from './cookbook/Policy'
import CookbookTerms from './cookbook/Terms'
import Meds from './meds'
import MedsPolicy from './meds/Policy'
import MedsTerms from './meds/Terms'

function Router() {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/meds/policy">
          <MedsPolicy />
        </Route>
        <Route path="/meds/terms">
          <MedsTerms />
        </Route>
        <Route path="/meds">
          <Meds />
        </Route>
        <Route path="/cookbook/policy">
          <CookbookPolicy />
        </Route>
        <Route path="/cookbook/terms">
          <CookbookTerms />
        </Route>
        <Route path="/cookbook">
          <Cookbook />
        </Route>
        <Route path="/poupe/policy">
          <PoupePolicy />
        </Route>
        <Route path="/poupe/terms">
          <PoupeTerms />
        </Route>
        <Route path="/poupe">
          <Poupe />
        </Route>
        <Route path="/rosary/policy">
          <RosaryPolicy />
        </Route>
        <Route path="/rosary/terms">
          <RosaryTerms />
        </Route>
        <Route path="/rosary">
          <Rosary />
        </Route>
        <Route path="/mercychaplet/policy">
          <MercyChapletPolicy />
        </Route>
        <Route path="/mercychaplet/terms">
          <MercyChapletTerms />
        </Route>
        <Route path="/mercychaplet">
          <MercyChaplet />
        </Route>
        <Route path="/">
          <App />
        </Route>
      </Switch>
    </BrowserRouter>
  )
}

export default Router
